const { MinimogThemeStyles, MinimogThemeScripts } = window;
class QuickView {
  constructor() {
    this.modal = new MinimogTheme.Modal();
    this.isOpen = false;

    addEventDelegate({
      selector: ".m-product-quickview-button",
      handler: (e, target) => {
        e.preventDefault();
        this.target = target;
        this.toggleLoading(this.target, true);
        const productHandle = target.dataset.productHandle;
        if (productHandle) this.fetchHtml(productHandle);
      },
    });

    window.MinimogEvents.subscribe(MinimogTheme.pubSubEvents.cartUpdate, () => {
      if (this.modal) MinimogTheme.ProductQuickView.close();
    });
  }

  fetchHtml(productHandle) {
    loadAssets([MinimogThemeStyles.product], "quick-view-assets");
    fetchSection("product-quickview", { url: `${window.MinimogSettings.base_url}products/${productHandle}` })
      .then((html) => {
        this.modalContent = html.querySelector(".m-product-quickview");
        const firstModel = html.querySelector("product-model");
        this.mediaGallery = this.modalContent.querySelector("media-gallery");
        loadAssets([MinimogThemeScripts.productMedia, MinimogThemeScripts.variantsPicker], "variants-picker", () => {
          this.modal.appendChild(this.modalContent);
          this.modal.setWidth("1040px");
          this.modal.setSizes("m-modal-quickview");
          this.modal.open();
          this.toggleLoading(this.target, false);
          this.isOpen = true;
          const tooltips = this.modalContent.querySelectorAll("[data-tippy-content]");
          tooltips &&
            tooltips.forEach((tooltip) => {
              MinimogLibs.Tooltip(tooltip, {
                theme: "minimog",
                touch: false,
                animation: "shift-toward",
              });
            });
        });

        if (window.Shopify && Shopify.PaymentButton) {
          Shopify.PaymentButton.init();
        }

        if (firstModel) {
          loadAssets(
            [
              MinimogThemeScripts.productModel,
              "https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.css",
            ],
            "product-model-assets"
          );
        }
      })
      .catch(console.error);
  }

  close(e) {
    this.modal.close(e);
    this.isOpen = false;
  }

  toggleLoading(target, loading) {
    if (loading) {
      target.classList.add("m-spinner-loading");
    } else {
      target.classList.remove("m-spinner-loading");
    }
  }
}

MinimogTheme.ProductQuickView = new QuickView();
